import React from "react";
import { DuePicker } from "@/components/TaskShared";

export function StartDateField({ value, onChange, testid, hint }) {
  return (
    <div className="max-w-[260px]" data-testid={`${testid}-field`}>
      <label className="text-[10px] text-[#9FA1A4] mb-1 block font-mono-data uppercase tracking-wide">Start date</label>
      <DuePicker testid={testid} value={value || null} onChange={(v) => onChange(v || "")} placeholder="Today" allowClear={false} />
      {hint && <p className="text-[11px] text-[#595D62] mt-1" data-testid={`${testid}-hint`}>{hint}</p>}
    </div>
  );
}
